import styled from "styled-components";

export const StyledBaseRatesWrapper = styled.div`
  .base-rates-head {
    padding: 20px 0 30px;
    display: grid;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;

    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
  }
  
  .rates-table {
    overflow: auto;
    overflow-scrolling: touch;
    &::-webkit-scrollbar {
      -webkit-appearance: none;
      height: 10px;
      background-color: #CEEBE4;
      border-radius: 20px;
    }
    &::-webkit-scrollbar-track{
      background-color: #CEEBE4;
      border-radius: 20px;
    }
    &::-webkit-scrollbar-thumb {
      height: 16px;
      border: 2px solid #CEEBE4;
      background: linear-gradient(40deg, #29DEAE -20.66%, #277661 68.48%);
      border-radius: 12px;
    }
    
    &__head, &__row {
      min-width: 1480px;
      width: 100%;
      padding: 0;
    }
    &__col {
      padding: 25px 20px;
    }
    &_col-fixed {
      background-color: #fff;
      position: sticky;
      left: 0;
      z-index: 10;
    }
    &__row:hover {
      .rates-table_col-fixed {
        background-color: #F5F4FA;
      }
    }
    
    @media screen and (max-width: 992px) {
      &__head {
        display: none;
      }
      &__row {
        min-width: 100%;
        margin-bottom: 15px;
        padding: 25px 20px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid #E5E5E5;
        overflow-x: inherit;
        & > div {
          padding-top: 20px;
          &:before {
            display: block;
          }
        }
      }
      &__col {
        padding: 0;
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
    }
  }
`;